import Vue from 'vue'
import {
  Icon,
  Popup,
  Dialog,
  Form,
  Field,
  Button,
  Sidebar,
  SidebarItem,
  Empty,
  Skeleton,
  Search,
  Tab, Tabs,
  Radio, RadioGroup,
  Cell, CellGroup,
  Tag,
  PullRefresh,
  Popover,
  NoticeBar,
  NavBar,
  Loading,
  Uploader,
} from 'vant'

Vue.use(Icon)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Empty)
Vue.use(Skeleton)
Vue.use(Search)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tag)
Vue.use(PullRefresh)
Vue.use(Popover)
Vue.use(NoticeBar)
Vue.use(NavBar)
Vue.use(Loading)
Vue.use(Uploader)